import { ForbiddenPage } from '@/pages/forbiden';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/forbidden')({
  component: ForbiddenPage,
});
